<template>
  <div>
    <div>
      <div class="data-source-step__target-name">
        {{targetName}}
      </div>
      <select-data-source v-model="selectedDataSource" />
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import SelectDataSource from './SelectDataSource'

export default {
  components: {
    SelectDataSource
  },
  props: {
    value: {
      completed: {
        type: Boolean,
        default: false
      },
      selectedDataSource: {
        default: null
      }
    },
    targetName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedDataSource: null
    }
  },
  created () {
    this.selectedDataSource = this.value.selectedDataSource
  },
  methods: {
    emit (v) {
      this.$emit('input', {
        completed: Boolean(v),
        selectedDataSource: v
      })
    }
  },
  watch: {
    selectedDataSource (value) {
      this.emit(value)
    }
  }
}

</script>

<style lang="scss">
.data-source-step {
  &__target-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
    line-height: 29px;
    margin: 20px 0 20px 0;
    color: #435262;
  }
}

</style>



// WEBPACK FOOTER //
// DataSourceStep.vue?d0d97c72